import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=6584216d&scoped=true&"
import script from "./Authorization.vue?vue&type=script&lang=ts&"
export * from "./Authorization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584216d",
  null
  
)

export default component.exports